import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { reduxForm, initialize, getFormValues } from "redux-form";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import moment from "moment";
import Modal from "../../../../Components/Modal";
import { getsensordevice_id, getsensorstatus, schakelkwhnmeter } from "../../../Sensors/Reducers/actions";
import AddKWHForm from "./forms/addkwh";
import AddAmpereForm from "./forms/ampere";
import { addwkhboeking, verplaatsboeking, changedatedepart, addgasten, changeampere } from "../../../GastenVerbruik/Reducers/actions";
import { createMeterUtils } from "./utils/meterUtils";
import "../../../../lib/css/components/meter-utils.scss";

const InstellenMeter = ({ getsensordevice_id, getsensorstatus, sensor, dispatch, showModal, boekingafronden, addwkhboeking, reloadplaatsen, schakelkwhnmeter, changeampere }) => {
  const [visible, setVisible] = useState(false);
  const [loadstatus, setLoadstatus] = useState(false);
  const [soortgast, setSoortgast] = useState(false);
  const [progress, setProgress] = useState(0);
  const [newgast, setNewgast] = useState(false);
  const [error, setError] = useState(false);
  const [addnewkwh, setAddnewkwh] = useState(false);
  const [ampere, setAmpere] = useState(false);
  const [aantaldagen, setAantaldagen] = useState(0);
  const [meterStatus, setMeterStatus] = useState(null);
  const [ampereStatus, setAmpereStatus] = useState(null);
  const [meterLoading, setMeterLoading] = useState(false);
  const [ampereLoading, setAmpereLoading] = useState(false);

  const meterUtils = createMeterUtils(setLoadstatus, setError, setProgress, setVisible, getsensorstatus, addwkhboeking, changeampere, schakelkwhnmeter, reloadplaatsen, setMeterStatus, setAmpereStatus, setMeterLoading, setAmpereLoading);
  useEffect(() => {
    if (visible) {
      getsensordevice_id(sensor.device).then(() => {
        // getstatus(data.results.device);
      });
    }
  }, [visible]);
  const formValues = useSelector(getFormValues("setupmeterinsert")); // vervang met je formuliernaam
  const vertrek = formValues?.vertrek;
  useEffect(() => {
    if (vertrek && soortgast?.gastenprofiel?.kwkinclusief > 0) {
      const vandaag = moment().startOf("day");

      const vertrekMoment = moment(vertrek).startOf("day");
      const dagenTussen = vertrekMoment.diff(vandaag, "days");
      setAantaldagen(dagenTussen);
      dispatch(initialize("setupmeterinsert", { ...formValues, kwh: soortgast.gastenprofiel.kwkinclusief * dagenTussen }));
    }
  }, [vertrek]);

  useEffect(() => {
    if (!showModal && visible) {
      setVisible(false);
      setProgress(0);
    }
    if (showModal.text && visible) {
      setLoadstatus(showModal.text);
      setProgress(0);
    }
  }, [showModal]);
  useEffect(() => {
    if (loadstatus) {
      let timeElapsed = 0;
      const interval = setInterval(() => {
        timeElapsed += 100;
        setProgress((prev) => Math.min(prev + 1, 100)); // Max 100%
        if (timeElapsed >= 10000) {
          clearInterval(interval);
          setLoadstatus(null);
          setProgress(0);
        }
      }, 100); // Elke 100ms +1%
      return () => clearInterval(interval);
    }
  }, [loadstatus]);

  return (
    <>
      <button className="btn btn-primary w-100" onClick={() => setVisible(true)}>
        <i className="fas fa-arrow-circle-right"></i> Plaats instellen
      </button>

      {createPortal(
        <Modal visible={visible} onClose={() => setVisible(false)} width="95vw" maxWidth={800}>
          <div className="card actionmodal">
            <div className="card-header">
              <h4 className="mb-0 text-truncate">{sensor.naam} instellen</h4>
            </div>

            <div className="box">
              {loadstatus && (
                <div className="overlay-loading">
                  <p>{loadstatus}</p>
                  <div className="progress">
                    <div className="progress-bar progress-bar-striped progress-bar-animated custom-progress-bar" style={{ width: `${progress}%` }}></div>
                  </div>
                </div>
              )}

              {sensor?.sensor?.boeking?._id && (
                <div className="p-3 p-md-4 d-flex flex-column">
                  <div className="d-flex flex-column gap-2 mb-3">
                    <div className="d-flex flex-column flex-sm-row">
                      <div className="me-2 fw-semibold text-nowrap">Geboekt door:</div>
                      <div className="text-break">
                        {sensor?.sensor?.boeking?.gastinfo?.voornaam} {sensor?.sensor?.boeking?.gastinfo?.tussennaam} {sensor?.sensor?.boeking?.gastinfo?.achternaam}
                      </div>
                    </div>

                    {sensor?.sensor?.boeking?.gastinfo?.bootnaam && (
                      <div className="d-flex flex-column flex-sm-row">
                        <div className="me-2 fw-semibold text-nowrap">Boot:</div>
                        <div className="text-break">{sensor.sensor.boeking.gastinfo.bootnaam}</div>
                      </div>
                    )}

                    {sensor?.sensor?.boeking?.vertrek && (
                      <div className="d-flex flex-column flex-sm-row">
                        <div className="me-2 fw-semibold text-nowrap">Vertrektijd:</div>
                        <div>{moment(sensor.sensor.boeking.vertrek).format("DD-MM-YYYY HH:mm")}</div>
                      </div>
                    )}
                    {sensor?.sensor?.kwh > 0 && (
                      <div className="d-flex flex-column flex-sm-row">
                        <div className="me-2 fw-semibold text-nowrap">Aantal kWh ingesteld:</div>
                        <div>{sensor.sensor.boeking.kwh} kWh</div>
                      </div>
                    )}
                    {sensor?.sensor?.boeking?.ampere > 0 && (
                      <div className="d-flex flex-column flex-sm-row">
                        <div className="me-2 fw-semibold text-nowrap">Aantal Ampere ingesteld:</div>
                        <div>{sensor.sensor.boeking.ampere} A</div>
                      </div>
                    )}
                  </div>
                  {/* Boeking Acties Groep */}
                  <div className="mb-2">
                    <h6 className="text-muted mb-1 small">
                      <i className="fas fa-clipboard-list me-1"></i>Boeking acties
                    </h6>
                    <div className="row row-cols-2 g-1">
                      <div className="col">
                        <button
                          type="button"
                          className="btn btn-sm btn-success w-100 p-1"
                          onClick={() =>
                            boekingafronden(sensor.sensor.boeking._id, {
                              boeking: sensor.sensor.boeking,
                              sensor_id: sensor.sensor._id,
                            })
                          }
                        >
                          <i className="fas fa-check me-1"></i>
                          <small>Afronden</small>
                        </button>
                      </div>
                      <div className="col">
                        <Link type="button" className="btn btn-sm btn-info text-white w-100 p-1" to={{ pathname: "/gastenverbruik/kampeerplaats/" + sensor?.sensor?.boeking._id }}>
                          <i className="fas fa-eye me-1"></i>
                          <small>Bekijken</small>
                        </Link>
                      </div>
                    </div>
                  </div>

                  {/* Meter Instellingen Groep */}
                  {(sensor?.sensor?.boeking?.kwh > 0 || sensor?.sensor?.boeking?.gastenprofiel?.instellenamp || sensor?.sensor?.boeking?.vertrek) && (
                    <div className="mb-2">
                      <h6 className="text-muted mb-1 small">
                        <i className="fas fa-cog me-1"></i>Meter instellingen
                      </h6>
                      <div className="row row-cols-2 g-1">
                        {sensor?.sensor?.boeking?.kwh > 0 && (
                          <div className="col">
                            <button type="button" className="btn btn-sm btn-warning w-100 p-1" onClick={() => setAddnewkwh(!addnewkwh)}>
                              <i className="fas fa-bolt me-1"></i>
                              <small>Extra kWh</small>
                            </button>
                          </div>
                        )}

                        {sensor?.sensor?.boeking?.gastenprofiel?.instellenamp && (
                          <div className="col">
                            <button type="button" className="btn btn-sm btn-warning w-100 p-1" onClick={() => setAmpere(!ampere)}>
                              <i className="fas fa-bolt me-1"></i>
                              <small>Ampere</small>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {addnewkwh && <AddKWHForm onSubmit={meterUtils.submitaddkwh(sensor, setAddnewkwh)} />}
                  {ampere && <AddAmpereForm onSubmit={meterUtils.submitchangeampere(sensor, setAmpere)} ampere={sensor.sensor.boeking.ampere} />}
                </div>
              )}
              {error && <div className="alert alert-danger m-2 m-md-4">{error}</div>}
              <div className="box-body p-2 p-md-3">
                <hr />
                <div className="meter-control p-2">
                  <h4 className="mb-3">
                    <i className="fas fa-tachometer-alt me-2"></i>Meter acties
                  </h4>
                  
                  {/* Status resultaten badges */}
                  {(meterStatus || ampereStatus || meterLoading || ampereLoading) && (
                    <div className="mb-4">
                      <h6 className="text-muted mb-2">
                        <i className="fas fa-info-circle me-2"></i>Status overzicht
                      </h6>
                      <div className="d-flex flex-wrap gap-2">
                        {meterLoading && (
                          <div className="badge meter-status-badge badge-secondary">
                            <i className="fas fa-spinner fa-spin me-1"></i>
                            <span className="d-none d-sm-inline">Status </span>ophalen...
                          </div>
                        )}
                        {!meterLoading && meterStatus && (
                          <div className={`badge meter-status-badge ${meterStatus.success ? 'badge-success' : 'badge-danger'}`}>
                            <i className="fas fa-tachometer-alt me-1"></i>
                            <span className="d-none d-sm-inline">Status: </span>{meterStatus.success}
                            {meterStatus.success && meterStatus.data && (
                              <span className="ms-1 d-none d-md-inline">
                                ({moment(meterStatus.timestamp).format('HH:mm:ss')})
                              </span>
                            )}
                          </div>
                        )}
                        {ampereLoading && (
                          <div className="badge meter-status-badge badge-secondary">
                            <i className="fas fa-spinner fa-spin me-1"></i>
                            <span className="d-none d-sm-inline">Ampere </span>ophalen...
                          </div>
                        )}
                        {!ampereLoading && ampereStatus && (
                          <div className={`badge meter-status-badge ${ampereStatus.success ? 'badge-info' : 'badge-danger'}`}>
                            <i className="fas fa-bolt me-1"></i>
                            <span className="d-none d-sm-inline">Ampere: </span>{ampereStatus.success ? `${ampereStatus.ampere} A` : ampereStatus.error}
                            {ampereStatus.success && (
                              <span className="ms-1 d-none d-md-inline">
                                ({moment(ampereStatus.timestamp).format('HH:mm:ss')})
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Status Ophalen Groep */}
                  <div className="mb-2">
                    <h6 className="text-muted mb-1 small">
                      <i className="fas fa-search me-1"></i>Status ophalen
                    </h6>
                    <div className="row row-cols-2 g-1">
                      <div className="col">
                        <button type="button" className="btn btn-sm btn-info w-100 p-1" onClick={() => meterUtils.getstatus(sensor.device)}>
                          <i className="fas fa-info-circle me-1"></i>
                          <small>Meter</small>
                        </button>
                      </div>
                      <div className="col">
                        <button type="button" className="btn btn-sm btn-warning w-100 p-1" onClick={() => meterUtils.getstatusampere(sensor.device)}>
                          <i className="fas fa-plug me-1"></i>
                          <small>Ampere</small>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Meter Schakelen Groep */}
                  <div className="mb-2">
                    <h6 className="text-muted mb-1 small">
                      <i className="fas fa-power-off me-1"></i>Meter schakelen
                    </h6>
                    <div className="row row-cols-2 g-1">
                      <div className="col">
                        <button type="button" className="btn btn-sm btn-danger w-100 p-1" onClick={() => {
                          if (window.confirm("Weet je zeker dat je de meter wilt uitschakelen?")) {
                            meterUtils.schakelenmeteractie(sensor)(false);
                          }
                        }}>
                          <i className="fas fa-power-off me-1"></i>
                          <small>Uit</small>
                        </button>
                      </div>
                      <div className="col">
                        <button type="button" className="btn btn-sm btn-primary w-100 p-1" onClick={() => {
                          if (window.confirm("Weet je zeker dat je de meter wilt inschakelen?")) {
                            meterUtils.schakelenmeteractie(sensor)(true);
                          }
                        }}>
                          <i className="fas fa-plug me-1"></i>
                          <small>Aan</small>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>,
        document.body
      )}
    </>
  );
};

const ReduxFormSensorEdit = reduxForm({
  form: "setupmeterinsert", // a unique identifier for this form
})(InstellenMeter);

const mapStateToProps = (state) => ({
  initialValues: state.form.setupmeterinsert?.initial || {},
});

export default connect(mapStateToProps, { getsensordevice_id, getsensorstatus, addgasten, addwkhboeking, verplaatsboeking, schakelkwhnmeter, changedatedepart, changeampere })(ReduxFormSensorEdit);
